export const duration = 2000;
